import React, { Fragment, useState, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import WebsiteVisitsChartCard from './WebsiteVisitsChartCard';
import Topic from './Topic';
import Contact from './Contact';
import Recommender from './Recommender';
import Country from './Country';
import ConservationsChartCard from './ConservationsChartCard';
import ChatTimeChartCard from './ChatTimeChartCard';
import Percentage from './Percentage';
import Number from './Number';
import UserQuestions from './UserQuestions';
import MessengerClickStats from './MessengerClickStats';
import MessengerVisitsChartCard from './MessengerVisitsChartCard';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import visitor from '../../../../../data/visitor';
import {
  Row,
  FormGroup,
  Label,
  Col,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import Axios from 'axios';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  week,
  month,
  last7Days,
  last30Days,
  last60Days,
  last90Days,
  LastDays,
  year,
} from './lablesConfig';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  gAPI_VisitorsGroups_Stats,
  gAPI_Topics_Stats,
  gAPI_Percentage_Stats,
  gAPI_Conversations_Stats,
  gAPI_Conversations_Night_Stats,
  API_CountriesGroups_Stats,
  gAPI_Conversations_VisitorQuestions,
  gAPI_Conversations_Stats_Year,
  gAPI_Conversations_Night_Year_Stats,
  gAPI_VisitorsGroupsMonth_Stats,
  gAPI_Number_Stats,
  gAPI_Conversations_Time_Stats,
  gAPI_Conversations_Night_Time_Stats,
  gAPI_Conversations_Time_Year_Stats,
  gAPI_Conversations_Night_Year_Time_Stats,
  gAPI_Recommender_Stats,
  gAPI_VisitorsGroupsContact_Stats,
  gAPI_TicketGroup_Stats,
  gAPI_Ticket_Stats_ByCategory,
  gAPI_BookingEngineSearch_Stats,
  API_Ingetration_Channels,
  gAPI_Messenger_Click,
  gAPI_Messenger_DateWiseStats,
  gAPI_Internal_Property_List,
  gAPI_AvatarClick_Stats,
  gAPI_AllPropertyStatsSummary,
} from '../../../../../constants/APIs';
import VoucherClicks from './VoucherClicks';
import VoucherEngineSales from './VoucherEngineSales';
import PopularVoucher from './PopularVoucher';
import RecentOrder from './RecentOrder';
import VoucherEngineVisits from './VoucherEngineVisits';
import topic from '../../../../../data/topic';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import TicketStatsByCategory from './TicketStatsByCategory';
import NumberTotalConversation from './NumberTotalConversation';

const dataTableColumnsContacts = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Phone',
    accessor: 'phone',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Zip Code',
    accessor: 'zipCode',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Marketing Consent',
    accessor: 'consent',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Date',
    accessor: 'consentDate',
    Cell: (props) => (
      <p className="">
        {props.value !== '' ? moment(props.value).format('lll') : ''}
      </p>
    ),
  },
];

const dataTableRecommenderColumns = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: 'Button',
    accessor: 'button',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
  {
    Header: 'Visits',
    accessor: 'visits',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
];

const dataTableMessengerColumns = [
  {
    Header: 'Title',
    accessor: 'title',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: 'Clicks',
    accessor: 'clicks',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
];
const countryDataTableColumns = [
  {
    Header: 'Country',
    accessor: 'country',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: 'Web Visitors',
    accessor: 'visitors',
    Cell: (props) => <p className="ml-5">{props.value}</p>,
  },
  // {
  //   Header: 'Avatar Clicks',
  //   accessor: 'messengerClicks',
  //   Cell: (props) => <p className="ml-5">{props.value}</p>,
  // },
  {
    Header: 'Avatar Clicks',
    accessor: 'botClicks',
    Cell: (props) => <p className="ml-5">{props.value}</p>,
  },
  {
    Header: 'Conversations',
    accessor: 'conversations',
    Cell: (props) => <p className="ml-5">{props.value}</p>,
  },
];
const voucherEngineVisits = [
  {
    Header: 'Country',
    accessor: 'country',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Clicks',
    accessor: 'clicks',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Visitors',
    accessor: 'visitors',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
];
const poupularVoucherDataTablescolumn = [
  {
    Header: 'Name',
    accessor: 'voucherName',
    Cell: (props) => <p>{props.value}</p>,
  },
  {
    Header: 'Views',
    accessor: 'views',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Added to Cart',
    accessor: 'cart',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Payments',
    accessor: 'payments',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Purchases',
    accessor: 'purchases',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
];
export default function ChartCard({
  propertyId,
  isVoucherEngine,
  timeZone,
  domains,
  currency,
  history,
  integrationIdList,
}) {
  moment.tz.setDefault(timeZone);
  const [buttonText, setButtonText] = useState(
    <IntlMessages id="dashboards.last-7-days" />
  );
  const [labels, setLabels] = useState(last7Days);
  const [visitorStatsData, setVisitorStatsData] = useState([]);
  const [topicsStatsData, setTopicsStatsData] = useState([]);
  const [contactStatsData, setContactStatsData] = useState([]);
  const [recommenderStatsData, setRecommenderStatsData] = useState([]);
  const [percentageStatsData, setPercentageStatsData] = useState([]);
  const [numberStatsData, setNumberStatsData] = useState([]);
  const [countriesStatsData, setCountriesStatsData] = useState([]);
  const [visitorQuestionsData, setvisitorQuestions] = useState([]);
  const [conversationStatsData, setConversationStatsData] = useState([]);
  const [conversationNightStatsData, setConversationNightStatsData] = useState(
    []
  );
  const [chattimeStatsData, setChatTimeStatsData] = useState([]);
  const [chattimeNightStatsData, setChatTimeNightStatsData] = useState([]);
  const [bookingEngineSearchData, setBookingEngineSearchData] = useState([]);
  const [messengerClickData, setMessengerClickData] = useState([]);
  const [messengerVisitStatsData, setMessengerVisitStatsData] = useState([]);
  const [ticketByCategoryData, setTicketByCategoryData] = useState([]);
  const [avatarClicksData, setAvatarClicksData] = useState([]);
  const [visitorQuestionsPageSize, setvisitorQuestionsPageSize] = useState(20);
  const [visitorQuestionsPageNumber, setvisitorQuestionsNumber] = useState(1);
  const [fromDate, setfromDate] = useState('');
  const [toDate, settoDate] = useState('');
  const [isloading, setLoading] = useState(true);
  const [isWebsiteVisit, setIsWebsiteVisit] = useState(true);
  const [isConversationGraph, setIsConversationGraph] = useState(true);
  const [isTopics, setTopics] = useState(true);
  const [isContact, setContacts] = useState(true);
  const [isRecommender, setRecommender] = useState(true);
  const [isCountry, setIsCountry] = useState(true);
  const [isChatEngagement, setIsChatEngagement] = useState(true);
  const [isPercentage, setIsPercentage] = useState(true);
  const [isUserQuestion, setIsUserQuestion] = useState(true);
  const [isChatTime, setIsChatTime] = useState(true);
  const [isTotalTicket, setIsTotalTicket] = useState(true);
  const [isMessengerStats, setIsMessengerStats] = useState(true);
  const [isMessengerVisitStats, setIsMessengerVisitStats] = useState(true);
  const [isTicketByCategory, setIsTicketByCategory] = useState(true);
  const [clicks, setClicks] = useState([]);
  const [isclicks, setIsClicks] = useState(true);
  const [sales, setSales] = useState([]);
  const [isSales, setIsSales] = useState(true);
  const [stats, setStats] = useState([]);
  const [isStats, setIsStats] = useState(true);
  const [statsData, setStatsData] = useState([]);
  const [countryvisit, setCountryVisit] = useState([]);
  const [isCountryStats, setIsCountryStats] = useState(true);
  const [totalTicketStats, setTotalTicketStats] = useState([]);
  const [isBookingEngineConnect, setIsBookingEngineConnect] = useState(false);
  const [isMessengerConnect, setIsMessengerConnect] = useState(false);
  // const [propertyLoaded, setpropertyLoaded] = useState(propertyId);
  const [isMasked, setIsMasked] = useState(sessionStorage.getItem('lock'));

  const [isShow, setIsShow] = useState(false);
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [filterDate, setFilterDate] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
  const [endDate, setEndDate] = useState(moment());
  const [propertyData, setPropertyData] = useState(null);
  const [isBusinessOperator, setIsBusinessOperator] = useState(false);
  const [isUtilityProvider, setIsUtilityProvider] = useState(false);
  const [hideWebwidgetStats, setHideWebwidgetStats] = useState(false);
  const [csvData, setCSVData] = useState([]);

  const maskEmail = (text) => {
    if (text !== null && text !== undefined) {
      let maskedvalue = text.replace(/()(.*)(?=@)/, function (gp1, gp2, gp3) {
        for (let i = 0; i < gp3.length; i++) {
          gp2 += 'X';
        }
        return gp2;
      });
      return maskedvalue;
    } else return '';
  };
  const maskMobile = (text, number) => {
    if (text !== null && text !== undefined) {
      let maskedValue = '';
      for (let i = 0; i < text.length - number; i++) {
        maskedValue += 'X';
      }
      return maskedValue + text.substring(text.length - number, text.length);
    } else return '';
  };
  const dataTableColumnsContacts = [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: (props) => (
        <p className="">
          {isMasked !== 'true' ? maskEmail(props.value) : props.value}
          <span
            className="text-muted ml-1"
            style={{ cursor: 'pointer', position: 'absolute' }}
            onClick={handleMaskClick}
          >
            {props.value !== '' && (
              <FontAwesomeIcon
                icon={isMasked === 'true' ? faLockOpen : faLock}
                className="fa"
              />
            )}
          </span>
        </p>
      ),
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: (props) => (
        <p className="ml-3">
          {isMasked !== 'true' ? maskMobile(props.value, 4) : props.value}
          <span
            className="text-muted ml-1"
            style={{ cursor: 'pointer' }}
            onClick={handleMaskClick}
          >
            {props.value !== '' && (
              <FontAwesomeIcon
                icon={isMasked === 'true' ? faLockOpen : faLock}
                className="fa"
              />
            )}
          </span>
        </p>
      ),
    },
    {
      Header: 'Zip Code',
      accessor: 'zipCode',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: 'Marketing Consent',
      accessor: 'consent',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: 'Date',
      accessor: 'consentDate',
      Cell: (props) => (
        <p className="">
          {props.value !== '' ? moment(props.value).format('lll') : ''}
        </p>
      ),
    },
  ];

  const dataTableTicketByCategoryColumns = [
    {
      Header: 'Category',
      accessor: 'category',
      Cell: (props) => (
        <p className="ml-2">
          <a
            className="btn-link"
            style={{ textDecoration: 'underline' }}
            onClick={() => handleNavigateToTicket(props.value)}
          >
            {props.value}
          </a>
        </p>
      ),
    },
    {
      Header: 'Ticket Count',
      accessor: 'ticketCount',
      Cell: (props) => <p className="ml-3">{props.value}</p>,
    },
  ];

  const handleNavigateToTicket = (value) => {
    history.push({
      pathname: '/app/pages/agent-assist',
      state: { categoryvalue: value },
    });
  };

  const handleMaskClick = () => {
    if (isMasked === 'true') {
      sessionStorage.setItem('lock', 'false');
      setIsMasked(sessionStorage.getItem('lock'));
    } else {
      sessionStorage.setItem('lock', 'true');
      setIsMasked(sessionStorage.getItem('lock'));
    }
  };
  const handlenavbooking = (value) => {
    history.push({
      pathname: '/app/pages/agent-assist',
      state: { tagName: value },
    });
  };
  const dataTableColumns = [
    {
      Header: 'Topic',
      accessor: 'topic',
      Cell: (props) => (
        <p className="ml-2">
          {topic.filter((e) => e.topic === props.value).length > 0 ? (
            <a
              className="btn-link"
              style={{ textDecoration: 'underline' }}
              onClick={() => handlenavbooking(props.value)}
            >
              {props.value}
            </a>
          ) : (
            props.value
          )}
        </p>
      ),
    },
    {
      Header: 'Conversations',
      accessor: 'conversations',
      Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
    {
      Header: 'Messages',
      accessor: 'messages',
      Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
  ];

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_List}?group_id=${getGroupID()}`,
    }).then((res) => {
      var allproperties = res.data;
      var isLocal = false;
      if (propertyId === '-1') {
        var totalwageRate = 0;
        var totalwageRateUSD = 0;
        var currency = '';
        var currencyProperty = allproperties.filter(
          (n) => n.currency !== null && n.currency !== ''
        );
        const allEqual = currencyProperty.every(
          (val) => val === currencyProperty[0]
        );
        if (allproperties.length === currencyProperty.length) {
          if (allEqual) {
            currency = currencyProperty[0].currency;
          } else {
            currency = 'USD';
          }
        }
        var hourly = allproperties.filter(
          (n) =>
            n.averageHourlyWageRate !== null && n.averageHourlyWageRate !== 0
        );
        if (allproperties.length === hourly.length) {
          totalwageRate = hourly[0].averageHourlyWageRate;
        }
        var hourlyUSD = allproperties.filter(
          (n) =>
            n.averageHourlyWageRateUSD !== null &&
            n.averageHourlyWageRateUSD !== 0
        );
        if (allproperties.length === hourlyUSD.length) {
          totalwageRateUSD = hourlyUSD[0].averageHourlyWageRateUSD;
        }
        // var propertyList = allproperties.filter(n => n.currency !== null && n.currency !== "");
        // propertyList.map(x => {
        //   if (propertyList.length > 0) {
        //     currency = propertyList[0].currency;
        //     isLocal = true;
        //   }
        //   totalwageRate = totalwageRate + x.averageHourlyWageRate;
        //   totalwageRateUSD = totalwageRate + x.averageHourlyWageRateUSD;
        // });
        var body = {
          currency: currency,
          totalwageRate: totalwageRate,
          totalwageRateUSD: totalwageRateUSD,
          isLocal: isLocal,
          isGroupLevel: true,
        };
        setPropertyData(body);
      } else {
        var propertydata = allproperties.filter((m) => m.id == propertyId);
        if (propertydata !== null && propertydata.length > 0) {
          if (propertydata[0].hideStats !== null) {
            setHideWebwidgetStats(propertydata[0].hideStats.hideWebWidget);
          }
          var totalwageRate = propertydata[0].averageHourlyWageRate;
          var totalwageRateUSD = propertydata[0].averageHourlyWageRateUSD;
          var currency = propertydata[0].currency;
          var body = {
            currency: currency,
            totalwageRate: totalwageRate,
            totalwageRateUSD: totalwageRateUSD,
            isLocal: isLocal,
            isGroupLevel: false,
          };
          setPropertyData(body);
        }
      }
    });

    selectLast7Days();
    let body = {
      channels: ['BookingEngineUrl', 'HelpCenter', 'HelpCenterGroup'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => {
      var getBookingEngine = res.data.filter(
        (i) => i.channel === 'BookingEngineUrl' && i.disabled !== true
      );
      if (getBookingEngine.length > 0) {
        if (propertyId !== '-1') {
          var channel = getBookingEngine.filter(
            (i) => i.propertyId === propertyId
          );
          if (channel.length > 0) {
            setIsBookingEngineConnect(true);
          }
        }
      }
      var helpcenter = res.data.filter(
        (i) => i.channel === 'HelpCenter' && i.disabled !== true
      );
      if (helpcenter.length > 0) {
        if (propertyId !== '-1') {
          if (
            helpcenter.filter((i) => i.properties.includes(propertyId)).length >
            0
          ) {
            setIsMessengerConnect(true);
          }
        }
      }
      var helpcentergroup = res.data.filter(
        (i) => i.channel === 'HelpCenterGroup' && i.disabled !== true
      );
      if (helpcentergroup.length > 0) {
        setIsMessengerConnect(true);
      }
    });
  }, [propertyId]);

  const today = () => {
    return moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const daysAgo7 = () => {
    return moment(moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo30 = () => {
    return moment(moment().subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo60 = () => {
    return moment(moment().subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo90 = () => {
    return moment(moment().subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const startOfWeek = () => {
    const today = moment();
    return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const endOfWeek = () => {
    const today = moment();
    return moment(
      moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfMonth = () => {
    return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const startOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
        ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfThisYear = () => {
    return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const startOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };
  const endOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const endOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
        ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };
  const loadMore = () => {
    const currentPage = visitorQuestionsPageNumber + 1;
    setvisitorQuestionsNumber(currentPage);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Conversations_VisitorQuestions}`,
      params: {
        groupId: getGroupID(),
        dateFrom: fromDate,
        dateTo: toDate,
        pageNumber: currentPage,
        pageSize: visitorQuestionsPageSize,
        propertyId: propertyId,
      },
    }).then((res) => {
      setLoading(true);
      const data = [...visitorQuestionsData, ...res.data];
      setvisitorQuestions(data);
    });
  };

  const endOfMonth = () => {
    return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  const selectLast7Days = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(daysAgo7(), today());
    }
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-7-days" />);
    setLabels(last7Days);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(daysAgo7());
    settoDate(today());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
          type: 0,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo7(),
          dateTo: today(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo7(),
          dateTo: today(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo7(),
          dateTo: today(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const selectLast30Days = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(daysAgo30(), today());
    }
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-30-days" />);
    setLabels(last30Days);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(daysAgo30());
    settoDate(today());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
          type: 0,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo30(),
          dateTo: today(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo30(),
          dateTo: today(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo30(),
          dateTo: today(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };
  const selectLast60Days = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(daysAgo60(), today());
    }
    setButtonText(<IntlMessages id="dashboards.last-60-days" />);
    setLabels(last60Days);
    setFilterDate(false);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(daysAgo60());
    settoDate(today());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
          type: 0,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo60(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo60(),
          dateTo: today(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo60(),
          dateTo: today(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo60(),
          dateTo: today(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };
  const selectLast90Days = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(daysAgo90(), today());
    }
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-90-days" />);
    setLabels(last90Days);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(daysAgo90());
    settoDate(today());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
          type: 0,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo90(),
          dateTo: today(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo90(),
          dateTo: today(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: daysAgo90(),
          dateTo: today(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const handleFilterDateWise = (startDate, endDate) => {
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(daysAgo90());
    settoDate(today());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
          type: 0,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startDate,
          dateTo: endDate,
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startDate,
          dateTo: endDate,
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startDate,
          dateTo: endDate,
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const selectThisWeek = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(startOfWeek(), endOfWeek());
    }
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.this-week" />);
    setLabels(week);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(startOfWeek());
    settoDate(endOfWeek());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
          type: 0,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const selectThisMonth = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(startOfMonth(), endOfMonth());
    }
    setButtonText(<IntlMessages id="dashboards.this-month" />);
    setLabels(month);
    setFilterDate(false);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(startOfMonth());
    settoDate(endOfMonth());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
          type: 0,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const selectPreviousMonth = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(startOfPreviousMonth(), endOfPreviousMonth());
    }
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.previous-month" />);
    setLabels(month);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(startOfPreviousMonth());
    settoDate(endOfPreviousMonth());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
          type: 0,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const selectThisYear = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(startOfThisYear(), today());
    }
    setButtonText(<IntlMessages id="dashboards.yeartodate" />);
    setLabels(year);
    setFilterDate(false);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(startOfThisYear());
    settoDate(today());
    setTopics(true);
    setIsCountry(false);
    setFilterDate(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroupsMonth_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats_Year}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
          type: 1,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Year_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Year_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Year_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfThisYear(),
          dateTo: today(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfThisYear(),
          dateTo: today(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfThisYear(),
          dateTo: today(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const selectLastYear = () => {
    if (propertyId === '-1') {
      downloadSummaryAll(startOfLastYear(), endOfLastYear());
    }
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.lastyear" />);
    setLabels(year);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(startOfLastYear());
    settoDate(endOfLastYear());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroupsMonth_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats_Year}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
          type: 1,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Year_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Year_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Year_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const handleFilterMonthWise = (startDate, endDate) => {
    if (propertyId === '-1') {
      downloadSummaryAll(startOfLastYear(), endOfLastYear());
    }
    setLabels(year);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(startOfLastYear());
    settoDate(endOfLastYear());
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Topics_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setTopicsStatsData(res.data);
        setTopics(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Recommender_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setRecommenderStatsData(res.data);
        setRecommender(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${API_CountriesGroups_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
          integrationIds: integrationIdList,
        },
      }).then((res) => {
        setCountriesStatsData(res.data);
        setIsCountry(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Percentage_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setPercentageStatsData(res.data);
        setIsPercentage(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Number_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setNumberStatsData(res.data);
        setIsChatTime(false);
      }),
      AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroupsMonth_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Stats_Year}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_AvatarClick_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
          type: 1,
        },
      }).then((res) => {
        setAvatarClicksData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Year_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setConversationNightStatsData(res.data);
        setIsConversationGraph(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Time_Year_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_Night_Year_Time_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setChatTimeNightStatsData(res.data);
        setIsChatEngagement(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Conversations_VisitorQuestions}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setvisitorQuestions(res.data);
        setIsUserQuestion(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_TicketGroup_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setTotalTicketStats(res.data);
        setIsTotalTicket(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setLoading(true);
        setBookingEngineSearchData(res.data);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_Click}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startDate,
          dateTo: endDate,
          lang: 'en',
        },
      }).then((res) => {
        setMessengerClickData(res.data);
        setIsMessengerStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_DateWiseStats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startDate,
          dateTo: endDate,
        },
      }).then((res) => {
        setMessengerVisitStatsData(res.data);
        setIsMessengerVisitStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ticket_Stats_ByCategory}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startDate,
          dateTo: endDate,
        },
      }).then((res) => {
        setTicketByCategoryData(res.data);
        setIsTicketByCategory(false);
      }),
    ]);
  };

  const handleFilter = () => {
    let diff = endDate.diff(startDate, 'days');
    setButtonText('Date Range');
    if (diff > 365) {
      setMessage('The start and end date must be within a year of each other.');
      setError(true);
      return;
    }
    if (diff > 90) {
      setIsShow(false);
      setLabels(year);
      handleFilterMonthWise(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59'
      );
      setFilterDate(true);
    } else {
      if (diff >= 60) setLabels(LastDays(startDate, endDate));
      else if (diff >= 30) setLabels(LastDays(startDate, endDate));
      else if (diff >= 7) setLabels(LastDays(startDate, endDate));
      else setLabels(LastDays(startDate, endDate));
      setIsShow(false);
      handleFilterDateWise(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59'
      );
      setFilterDate(true);
    }
  };
  if (Array.isArray(domains) && isBusinessOperator === false) {
    domains.forEach((r) => {
      if (r.type === 'BusinessOperator') {
        setIsBusinessOperator(true);
      }
    });
  }
  if (Array.isArray(domains) && isUtilityProvider === false) {
    domains.forEach((r) => {
      if (r.type === 'UtilityProviders') {
        setIsUtilityProvider(true);
      }
    });
  }
  const downloadSummaryAll = (datefrom, dateto) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_AllPropertyStatsSummary}`,
      params: {
        groupId: getGroupID(),
        dateFrom: datefrom,
        dateTo: dateto,
      },
    }).then((res) => {
      var tablePrint = [
        {
          r1: 'Start Date :' + datefrom,
          r2: '',
          r3: 'End Date :' + dateto,
          r4: '',
          r5: '',
          r6: '',
          r7: '',
          r8: '',
          r9: '',
          r10: '',
          r11: '',
          r12: '',
          r13: '',
          r14: '',
          r15: '',
          r16: '',
          r17: '',
        },
        {},
        {
          r1: 'Property',
          r2: 'Estimated Time Saving (Hours)',
          r3: 'Estimated Time Saving (NZD)',
          r4: 'Avatar Clicks',
          r5: 'Total Conversations',
          r6: 'Total User Messages',
          r7: 'Website Conversations',
          r8: 'WhatsApp Conversations',
          r9: 'Facebook Conversations',
          r10: 'Insta Conversations',
          r11: 'Tickets',
          r12: 'Contact',
          r13: 'Consented Contacts',
          r14: 'Booking Engine Leads',
          r15: 'Room Nights Referred',
          r16: 'Room Revenue Referred (NZD)',
          r17: 'Room Revenue Referred (USD)',
        },
      ];
      if (res.data.length > 0 && res.data.length > 0) {
        res.data.map((elem) => {
          tablePrint.push({
            r1: elem.propertyName,
            r2: elem.estimateTimeSavingHours,
            r3: elem.estimateTimeSavingNZD,
            r4: elem.totalAvatarClicks,
            r5: elem.totalConversations,
            r6: elem.totalUsersMessages,
            r7: elem.websiteConversations,
            r8: elem.whatsAppConversations,
            r9: elem.facebookConversations,
            r10: elem.instagramConversations,
            r11: elem.tickets,
            r12: elem.contacts,
            r13: elem.consentsContacts,
            r14: elem.bookingEngineLeads,
            r15: elem.roomNightsReferred,
            r16: elem.roomsRevenueReferredNZD,
            r17: elem.roomsRevenueReferredUSD,
          });
        });
      }
      setCSVData(tablePrint);
    });
  };
  return (
    <Fragment>
      <Row>
        <Col xxs="12" className="mb-2">
          <Fragment>
            {filterDate === true && (
              <div className="float-left mt-2">
                <span className="mr-2">
                  <b>From : </b>
                  {moment(startDate).format('DD')}/
                  {moment(startDate).format('MM')}/
                  {moment(startDate).format('YYYY')}
                </span>
                <span className="ml-2">
                  <b>To : </b>
                  {moment(endDate).format('DD')}/{moment(endDate).format('MM')}/
                  {moment(endDate).format('YYYY')}
                </span>
              </div>
            )}
            <div className="btn-group float-right float-none-xs mb-3">
              {propertyId === '-1' && (
                <CSVLink
                  data={csvData}
                  headers={[
                    { key: 'r1', label: '' },
                    { key: 'r2', label: '' },
                    { key: 'r3', label: '' },
                    { key: 'r4', label: '' },
                    { key: 'r5', label: '' },
                    { key: 'r6', label: '' },
                    { key: 'r7', label: '' },
                    { key: 'r8', label: '' },
                    { key: 'r9', label: '' },
                    { key: 'r10', label: '' },
                    { key: 'r11', label: '' },
                    { key: 'r12', label: '' },
                    { key: 'r13', label: '' },
                    { key: 'r14', label: '' },
                    { key: 'r15', label: '' },
                    { key: 'r16', label: '' },
                    { key: 'r17', label: '' },
                  ]}
                  filename="summary-stats.csv"
                >
                  <Button color="primary" outline size="xs" className="mr-2">
                    Download Summary
                  </Button>
                </CSVLink>
              )}
              <UncontrolledDropdown>
                <DropdownToggle
                  caret
                  color="primary"
                  className="btn-xs"
                  outline
                >
                  {buttonText}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={selectLast7Days}>
                    <IntlMessages id="dashboards.last-7-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast30Days}>
                    <IntlMessages id="dashboards.last-30-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast60Days}>
                    <IntlMessages id="dashboards.last-60-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast90Days}>
                    <IntlMessages id="dashboards.last-90-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisWeek}>
                    <IntlMessages id="dashboards.this-week" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisMonth}>
                    <IntlMessages id="dashboards.this-month" />
                  </DropdownItem>
                  <DropdownItem onClick={selectPreviousMonth}>
                    <IntlMessages id="dashboards.previous-month" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisYear}>
                    <IntlMessages id="dashboards.yeartodate" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLastYear}>
                    <IntlMessages id="dashboards.lastyear" />
                  </DropdownItem>
                  <DropdownItem onClick={() => setIsShow(!isShow)}>
                    Date Range
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </Fragment>
        </Col>
      </Row>
      <Row>
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12" className="mb-4">
            {isChatTime ? (
              <div className="text-center loading" />
            ) : (
              <Fragment>
                <NumberTotalConversation
                  history={history}
                  numbertimedata={numberStatsData}
                  fromDate={fromDate}
                  toDate={toDate}
                  messengerAvatar={
                    isMessengerConnect ? messengerClickData.avatarClick : null
                  }
                />
              </Fragment>
            )}
          </Col>
        ) : (
          ''
        )}
        <Col sm="12" md="6" className="mb-4">
          {isWebsiteVisit ? (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div>
          ) : (
            <WebsiteVisitsChartCard
              labels={labels}
              visitorStatsData={visitorStatsData}
            />
            // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
          )}
        </Col>
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isConversationGraph ? (
              <div className="text-center loading" />
            ) : (
              <ConservationsChartCard
                labels={labels}
                conversationStatsData={conversationStatsData}
                conversationNightStatsData={conversationNightStatsData}
                fromDate={fromDate}
                toDate={toDate}
                chattimeStatsData={chattimeStatsData}
                chattimeNightStatsData={chattimeNightStatsData}
                visitorStatsData={visitorStatsData}
                avatarclickdata={avatarClicksData}
              />
            )}
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12">
            {isPercentage ? (
              <div className="text-center loading" />
            ) : (
              <Fragment>
                <Percentage data={percentageStatsData} />
              </Fragment>
            )}
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isCountry ? (
              <div className="text-center loading" />
            ) : (
              <Country
                labels={countryDataTableColumns}
                data={countriesStatsData}
                fromDate={fromDate}
                toDate={toDate}
              />
              // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
            )}
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isChatEngagement ? (
              <div className="text-center loading" />
            ) : (
              <ChatTimeChartCard
                labels={labels}
                chattimeStatsData={chattimeStatsData}
                chattimeNightStatsData={chattimeNightStatsData}
                fromDate={fromDate}
                toDate={toDate}
              />
            )}
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isTopics ? (
              <div className="text-center loading" />
            ) : (
              <Topic
                labels={dataTableColumns}
                data={topicsStatsData}
                fromDate={fromDate}
                toDate={toDate}
              />
            )}
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1 ? (
          isUtilityProvider === false && isBusinessOperator === false ? (
            <Col sm="12" md="6" className="mb-4">
              {isRecommender ? (
                <div className="text-center">
                  <Spinner color="primary" className="mb-1" />
                </div>
              ) : (
                <Recommender
                  labels={dataTableRecommenderColumns}
                  data={recommenderStatsData}
                  fromDate={fromDate}
                  toDate={toDate}
                />
              )}
            </Col>
          ) : (
            ''
          )
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1
          ? isMessengerConnect &&
            !hideWebwidgetStats && (
              <Col sm="12" md="6" className="mb-4">
                {isMessengerStats ? (
                  <div className="text-center">
                    <Spinner color="primary" className="mb-1" />
                  </div>
                ) : (
                  <MessengerClickStats
                    labels={dataTableMessengerColumns}
                    data={
                      messengerClickData.itemClicks === null
                        ? []
                        : messengerClickData.itemClicks
                    }
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                )}
              </Col>
            )
          : ''}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isUserQuestion ? (
              <div className="text-center loading" />
            ) : (
              <UserQuestions
                data={visitorQuestionsData}
                isloading={isloading}
                loadMore={loadMore}
              />
            )}
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1
          ? isMessengerConnect &&
            !hideWebwidgetStats && (
              <Col sm="12" md="6" className="mb-4">
                {isMessengerStats ? (
                  <div className="text-center">
                    <Spinner color="primary" className="mb-1" />
                  </div>
                ) : (
                  <MessengerVisitsChartCard
                    labels={labels}
                    data={messengerVisitStatsData}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                )}
              </Col>
            )
          : ''}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isTicketByCategory ? (
              <div className="text-center loading" />
            ) : (
              <TicketStatsByCategory
                labels={dataTableTicketByCategoryColumns}
                data={ticketByCategoryData}
                fromDate={fromDate}
                toDate={toDate}
              />
            )}
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12">
            {isChatTime ? (
              <div className="text-center loading" />
            ) : (
              <Fragment>
                <Number
                  numbertimedata={numberStatsData}
                  messengerAvatar={
                    isMessengerConnect ? messengerClickData.avatarClick : null
                  }
                  propertyData={propertyData}
                  isBusinessOperator={isBusinessOperator}
                  isUtilityProvider={isUtilityProvider}
                />
              </Fragment>
            )}
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12">
            {isChatTime || isTotalTicket ? (
              <div className="text-center loading" />
            ) : (
              <Number
                history={history}
                numberdata={numberStatsData}
                totalTicketStats={totalTicketStats}
                bookingEngineStats={recommenderStatsData}
                fromDate={fromDate}
                toDate={toDate}
                isBookingEngineConnect={isBookingEngineConnect}
                bookingEngineSearchData={bookingEngineSearchData}
                contactStatsData={contactStatsData}
                isBusinessOperator={isBusinessOperator}
                isUtilityProvider={isUtilityProvider}
                propertyData={propertyData}
                propertyId={propertyId}
              />
            )}
          </Col>
        ) : (
          ''
        )}
        <Col sm="12" md="12" className="mb-4">
          {isContact ? (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div>
          ) : (
            <Contact
              labels={dataTableColumnsContacts}
              data={contactStatsData}
              timeZone={timeZone}
              propertyId={propertyId}
              isMasked={isMasked}
            />
          )}
        </Col>
      </Row>

      <Modal
        isOpen={isShow}
        toggle={() => setIsShow(!isShow)}
        style={{ borderRadius: '10px' }}
      >
        <ModalHeader toggle={() => setIsShow(!isShow)}>Date Range</ModalHeader>
        <ModalBody>
          <Row>
            <Colxx md="4" className="mb-2">
              <FormGroup>
                <Label>Start Date</Label>
                <DatePicker
                  style={{ borderRadius: '10px' }}
                  selected={startDate}
                  onChange={handleStartDate}
                  placeholderText="Start Date"
                  dateFormat="DD/MM/YYYY"
                />
              </FormGroup>
            </Colxx>

            <Colxx md="4" className="mb-2">
              <FormGroup>
                <Label>End Date</Label>
                <DatePicker
                  style={{ borderRadius: '10px' }}
                  selected={endDate}
                  onChange={handleEndDate}
                  placeholderText="End Date"
                  dateFormat="DD/MM/YYYY"
                />
              </FormGroup>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleFilter()}>
            Submit
          </Button>
          <Button className="ml-2" onClick={() => setIsShow(!isShow)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isError}
        toggle={() => setError(!isError)}
        style={{ borderRadius: '10px' }}
      >
        <ModalHeader toggle={() => setError(!isError)}>BOOKMEBOB</ModalHeader>
        <ModalBody>
          <Row>
            <p className="m-2">{message}</p>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="ml-2" onClick={() => setError(!isError)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
